jQuery(document).ready(function( $ ) {

    $('.cta-link-invisible').click(function( e ) {
        window.open( theme.cta_link );
    });

});